import { defaultTheme, zIndexDialog } from "../../styles/index.mjs";
import styled from "../../styled-components.mjs";
export var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1eu55v9-0"
})(["background:", ";color:", ";display:flex;flex-direction:column;position:fixed;inline-size:100%;block-size:100%;top:0;left:0;z-index:", ";overflow-wrap:break-word;"], function (props) {
  return "var(--background-base, ".concat(defaultTheme[props.colorSet].background.base, ")");
}, function (props) {
  return "var(--text-base, ".concat(defaultTheme[props.colorSet].text.base, ")");
}, zIndexDialog);